import { render, staticRenderFns } from "./SendCode.vue?vue&type=template&id=adcd65b2"
import script from "./SendCode.vue?vue&type=script&lang=js"
export * from "./SendCode.vue?vue&type=script&lang=js"
import style0 from "./SendCode.vue?vue&type=style&index=0&id=adcd65b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports